"use client";

import React from "react";

export const Footer: React.FC = () => {
  return (
    <footer
      className="mt-[clamp(64px,8vw,100px)] pb-8 pt-[clamp(40px,6vw,64px)]"
      style={{ background: "var(--techno-black)", color: "var(--rev-white)" }}
    >
      <div className="gl-container">
        {/* Top grid */}
        <div
          className="grid grid-cols-2 gap-[clamp(28px,4vw,64px)] pb-[clamp(28px,4vw,48px)] md:grid-cols-[2fr_1fr_1fr_1fr]"
          style={{ borderBottom: "1px solid rgba(255,255,255,0.1)" }}
        >
          {/* Brand col */}
          <div className="col-span-2 md:col-span-1">
            <h4
              className="mb-4 leading-snug"
              style={{
                fontFamily: "var(--font-display)",
                fontSize: "clamp(28px,4vw,36px)",
                fontWeight: 400,
                letterSpacing: "-1px",
              }}
            >
              Tech meets{" "}
              <em style={{ color: "var(--turmeric)", fontStyle: "italic" }}>Local.</em>
            </h4>
            <p
              className="max-w-[380px] leading-relaxed"
              style={{ fontSize: 14, color: "rgba(232,234,226,0.6)" }}
            >
              GrabLocal is a curated marketplace where homegrown brands meet the
              customers who appreciate them. We curate, empower, connect.
            </p>
          </div>

          {/* Shoppers */}
          <FooterCol
            heading="For Shoppers"
            links={["Browse stores", "Categories", "Track order", "Help center"]}
          />

          {/* Sellers */}
          <FooterCol
            heading="For Sellers"
            links={["GrabLocal 360", "Apply to list", "Seller stories", "Pricing"]}
          />

          {/* Company */}
          <FooterCol
            heading="Company"
            links={["About", "Careers", "Press", "Contact"]}
          />
        </div>

        {/* Bottom bar */}
        <div
          className="flex flex-wrap items-center justify-between gap-3 pt-7"
          style={{ fontSize: "12.5px", color: "rgba(232,234,226,0.5)" }}
        >
          <span>© 2026 Solkuu Technologies Pvt Ltd. Curate · Empower · Connect.</span>
          <span>Made with care in Bengaluru</span>
        </div>
      </div>
    </footer>
  );
};

const FooterCol: React.FC<{ heading: string; links: string[] }> = ({ heading, links }) => (
  <div>
    <h5
      className="mb-[18px] font-bold uppercase tracking-[1.8px]"
      style={{ fontSize: 11, color: "rgba(232,234,226,0.5)" }}
    >
      {heading}
    </h5>
    <ul className="flex flex-col gap-3">
      {links.map((link) => (
        <li key={link}>
          <a
            href="#"
            className="text-sm transition-colors"
            style={{ color: "rgba(232,234,226,0.85)" }}
            onMouseEnter={e => (e.currentTarget.style.color = "var(--turmeric)")}
            onMouseLeave={e => (e.currentTarget.style.color = "rgba(232,234,226,0.85)")}
          >
            {link}
          </a>
        </li>
      ))}
    </ul>
  </div>
);
